import useCountryBlocked from '~/client/hooks/user/useCountryBlocked';
import DefaultSignupButton from './shared/DefaultSignupButton';
import type SignupButtonProps from './shared/SignupButtonProps';
import BlockedCountryButton from '../BlockedCountryButton';

const SignupButton: FC<SignupButtonProps> = (props) => {
  const { isCountryBlocked } = useCountryBlocked();
  if (isCountryBlocked) {
    return <BlockedCountryButton id="profile.signup" variant="primary" />;
  }
  return <DefaultSignupButton {...props} />;
};

export default SignupButton;
